import { injectCarrot } from './inject-carrot';

const showBlockedModal = () => {
  const modal = document.querySelector('#intercom-blocked');

  if (!modal) {
    return;
  }

  if (window.$ && typeof window.$.fn?.modal === 'function') {
    window.$(modal).modal('show');
  } else {
    modal.classList.remove('_hidden');
  }
};

const handleActivateClick = (e) => {
  if (!e.target.closest('.intercom-activate')) {
    return;
  }

  injectCarrot();

  if (typeof carrotquest === 'undefined') {
    showBlockedModal();

    return;
  }

  if ('open' in carrotquest) {
    carrotquest.open();
  }
};

const init = () => {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(injectCarrot, { timeout: 4000 });
  } else {
    setTimeout(injectCarrot, 2000);
  }

  document.addEventListener('click', handleActivateClick);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
